import { useQuery } from '@tanstack/react-query'

import { fetchCourtPriceDates } from '@/lib/venue/priceApi'
import type { CourtPriceDateListView } from '@/lib/venue/priceTypes'

export function courtPriceDatesQueryKey(venueId: string, courtId: number, from: string, to: string) {
  return ['venue', venueId, 'courts', courtId, 'price-dates', from, to] as const
}

/** 날짜 지정 요금 목록(#866 API ④). `from`/`to` 는 화면이 KST 기준으로 계산해 넘긴다(설계 D7). */
export function useCourtPriceDates(venueId: string, courtId: number, from: string, to: string) {
  return useQuery<CourtPriceDateListView>({
    queryKey: courtPriceDatesQueryKey(venueId, courtId, from, to),
    queryFn: () => fetchCourtPriceDates(venueId, courtId, from, to),
    // 기준일(`baseTime`)이 정해진 뒤에만 조회한다 — 빈 범위로 400 을 부르지 않는다.
    enabled: Boolean(from && to),
  })
}
